<div class="paginationDs__cont" *ngIf="hasPageControls">
  <div class="paginationDs__arrow-controls" *ngIf="moveControl">
    <div class="paginationDs__arrow-controls__prev">
      <app-ds-icon
        [icon]="prevIcon"
        [size]="30"
        [color]="iconColor"
        (click)="moveMarker({ add: false, subtract: true })">
      </app-ds-icon>
    </div>
    <div class="paginationDs__arrow-controls__next">
      <app-ds-icon
        [icon]="nextIcon"
        [size]="30"
        [color]="iconColor"
        (click)="moveMarker({ add: true, subtract: false })">
      </app-ds-icon>
    </div>
  </div>
  <div class="paginationDs__slide-control">
    <div class="paginationDs__slide-control__cont paginationDs__slide-control__cont--{{type}}">
      <div class="paginationDs__slide-control__cont__slider paginationDs__slide-control__cont__slider--{{type}}">
        <ng-container *ngFor="let page of pageList; trackBy: trackById; last as isLast">
          <div
            class="paginationDs__slide-control__cont__slider__page paginationDs__slide-control__cont__slider__page--{{type}}"
            [class.active]="pageHasBeenActivated(page)"
            [class.progress]="runProgress(page)"
            [class.see-hover]="seeHover"
            [class.last]="isLast"
            (click)="setMarker(page)">
            <span
              class="paginationDs__slide-control__cont__slider__page__loader paginationDs__slide-control__cont__slider__page__loader--{{type}}"
              [class.progress]="runProgress(page)">
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>